import { DefaultCustomField } from 'src/constants/types';

export function messageHasCustomFieldsWithoutDefaultValue(
  messageHtml: string,
  customFields: DefaultCustomField[],
): boolean {
  const container = document.createElement('div');
  container.innerHTML = messageHtml;
  const fields = container.querySelectorAll('span.mention');
  let result = false;
  fields.forEach(f => {
    const customField = customFields.find(cf => cf.name === f.getAttribute('data-id'));
    if (
      customField &&
      !customField.hasDefaultValue &&
      !customField.name.startsWith('appointment')
    ) {
      result = true;
      return;
    }
  });
  return result;
}
